"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// byteLengthLimit.js
var _default = exports.default = {
  bind: function bind(el, binding) {
    var maxLength = binding.value;
    var inputElement = el.querySelector('input, textarea');
    function calculateByteLength(str) {
      var blob = new Blob([str], {
        type: 'text/plain',
        charset: 'utf-8'
      });
      return blob.size;
    }
    function truncateInput(value) {
      var truncatedValue = value;
      while (calculateByteLength(truncatedValue) > maxLength && truncatedValue.length > 0) {
        truncatedValue = truncatedValue.slice(0, -1);
      }
      return truncatedValue;
    }
    function handleInput() {
      var newValue = inputElement.value;
      newValue = truncateInput(newValue);
      inputElement.value = newValue;
      // 这里不需要手动触发 input 事件，因为 Vue 会自动处理
    }
    // 监听 input 事件
    inputElement.addEventListener('input', handleInput);

    // 在指令解绑时移除事件监听器
    el._handleInput = handleInput;
  },
  unbind: function unbind(el) {
    var inputElement = el.querySelector('input, textarea');
    inputElement.removeEventListener('input', el._handleInput);
    delete el._handleInput;
  }
};